module.exports = __webpack_public_path__ + "static/media/medixtal.539baa4e.jpg";